import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogContent, MatDialogActions, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Api } from 'src/app/services/api';
import { SharedModule } from 'src/app/shared/shared-module';
import Swal from 'sweetalert2';


interface OvertimeList {
  id: number;
  employeeName: string;
  fecha: string;
  startTime: string;
  endTime: string;
  totalHours: number;
  overtimeType: string;
  reason: string;
  approved: string;
  rejected: string;
  processedby: string;
  comment: string;
  paid: string;
  paid_date: string | null;
}

@Component({
   selector: 'app-overtime',
  imports: [SharedModule,  CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatCheckboxModule,
    ReactiveFormsModule],
  standalone: true,
  templateUrl: './overtime.html',
  styleUrl: './overtime.scss'
})
export class Overtime implements OnInit, AfterViewInit {
totalHoursdata = 0;
  overtimeForm!: FormGroup;
overtimeRequests: OvertimeList[] = [];
myrole= localStorage.getItem('rol') || '';
viewOVTForm:boolean = false;
  overtimeTypes = [
    { value: 'REGULAR', label: 'Regular Overtime' },
    { value: 'HOLIDAY', label: 'Holiday Overtime' },
    { value: 'PROJECT', label: 'Project Deadline / Delivery' },
    { value: 'COVERAGE', label: 'Operational Coverage' }
  ];
  dialog: any;

  constructor(private fb: FormBuilder, private apiservice:Api,  private dialogRef: MatDialogRef<Overtime>) {}

  ngOnInit(): void {
    let name = `${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`
    this.overtimeForm = this.fb.group({
      employeeName: [`${name}`, Validators.required],
      fecha: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      totalHours: [{ value: 0, disabled: true }],
      overtimeType: ['', Validators.required],
      reason: ['', Validators.required]
    });

    this.overtimeForm.valueChanges.subscribe(() => {
      this.calculateHours();
    });
  }
ngAfterViewInit(): void {
  if(this.apiservice.roleJustAdmin.includes(localStorage.getItem('rol') || '')){
    console.log('soy admin');
    this.viewOVTForm = true;
  }
    this.getOvertime();
}
  calculateHours(): void {
    const start = this.overtimeForm.get('startTime')?.value;
    const end = this.overtimeForm.get('endTime')?.value;

    if (start && end) {
      const startDate = new Date(`1970-01-01T${start}`);
      const endDate = new Date(`1970-01-01T${end}`);

          const diff = (endDate.getTime() - startDate.getTime()) / 3600000;

        const totalHours = diff > 0 ? Math.round(diff * 100) / 100 : 0;
        this.overtimeForm.patchValue(
          { totalHours },
          { emitEvent: false }
        );
        this.totalHoursdata = totalHours;
    }
  }


  openOvertimeDetails(ot: OvertimeList): void {

  Swal.fire({
    title: 'Overtime Details',
    icon:
      ot.approved === '1'
        ? 'success'
        : ot.rejected === '1'
          ? 'error'
          : 'info',
    html: `
      <b>Date:</b> ${ot.fecha}<br/>
      <b>Time:</b> ${ot.startTime} - ${ot.endTime}<br/>
      <b>Total Hours:</b> ${ot.totalHours}<br/>
      <b>Type:</b> ${ot.overtimeType}<br/><br/>

      <b>Reason:</b><br/>
      ${ot.reason}<br/><br/>

      <b>Manager Comment:</b><br/>
      ${ot.comment || 'N/A'}
    `,
    confirmButtonText: 'Close'
  });
}

getOvertime(){
  console.log('role ',localStorage.getItem('rol') ,'none ', this.apiservice.roleListTeacher.includes(localStorage.getItem('rol') || '') );

  let employeeid = this.apiservice.roleListTeacher.includes(localStorage.getItem('rol') || '') ? `employeeId = ${localStorage.getItem('teachID')}` : `employeeId = ${localStorage.getItem('userid')}`;
  console.log('overtime ', employeeid)
  this.apiservice.getForTable('overtime', employeeid).subscribe({
    next:(ot)=>{
      console.log('ovetime ', ot);
        this.overtimeRequests = ot;
    },error:(er)=>{
      console.error('error', er.error.error);
    }
  })
}
SaveRequest(){
    let employeeid = this.apiservice.roleListTeacher.includes(localStorage.getItem('role') || '') ? `${localStorage.getItem('teachID')}` : `${localStorage.getItem('userid')}`;

  let payload = this.overtimeForm.value;
  payload.totalHours = this.totalHoursdata;
  payload.employeeId = employeeid;
  this.apiservice.addItem(payload, 'overtime').subscribe({
    next:(saved)=>{
      console.log(saved);
      this.apiservice.showMessageWithAnimation('Overtime solicitado', 'success');
      this.close();
    },
    error:(er)=>{
      console.error('error', er.error.error);
    }
  })
}
close(){
  this.dialogRef.close();
}
}


